import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ContactSupportIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M11.75 19h-.25q-3.55 0-6.025-2.475T3 10.5t2.475-6.025T11.5 2a8.3 8.3 0 0 1 3.313.663 8.6 8.6 0 0 1 4.524 4.525A8.3 8.3 0 0 1 20 10.5q0 3.35-1.887 6.225-1.888 2.876-4.763 4.5-.25.125-.5.137a.76.76 0 0 1-.45-.112 1.3 1.3 0 0 1-.35-.325.9.9 0 0 1-.175-.475zm-.275-3.025q.425 0 .725-.3t.3-.725-.3-.725-.725-.3-.725.3-.3.725.3.725.725.3M9.3 8.375a.67.67 0 0 0 .55.012q.274-.112.45-.362.225-.3.525-.463.3-.162.675-.162.6 0 .975.337.375.339.375.863 0 .325-.187.65-.188.325-.663.8-.625.55-.925 1.037-.3.488-.3.988 0 .3.213.513a.7.7 0 0 0 .512.212q.3 0 .5-.225a1.5 1.5 0 0 0 .3-.525q.125-.425.45-.775t.6-.625q.525-.525.787-1.05.263-.525.263-1.05 0-1.15-.787-1.85Q12.825 6 11.5 6q-.8 0-1.475.388-.675.387-1.1 1.062a.59.59 0 0 0-.038.537.73.73 0 0 0 .413.388"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
